import React, { Fragment } from 'react';
import PathToRegexp from 'path-to-regexp';
import { resolve } from 'library/helpers/path-resolver';
import HiringLogo from 'apps/hiring/components/logo';
import Helmet from 'react-helmet';
import Carrot from 'library/icons/caret.svg';
import { NavLink, withRouter } from 'library/util/core-router';
import ScrollAnimation, { ScrollTop } from 'library/util/scroll';
import { ShimmyZone, withShimmy } from 'library/components/shimmy';
import OpeningSvg from 'library/icons/opening.svg';
import TargetSvg from 'library/icons/targets.svg';
import UserSvg from 'library/icons/users.svg';

class LogoArea extends React.Component {
  render() {
    const {
      scrollPos,
      shimmy
    } = this.props;

    return (
      <div
        className="pairin-hiring-logo"
      >
        <HiringLogo />
        <ShimmyZone namespace="hiring-navigation-logo-text">
          <div className="pairin-hiring-logo-breadcrumbs">
            <h1>
              Hiring
            </h1>
            <h2>
              <small>
                { shimmy.slice(-3,-1) }
                <Carrot />
              </small>
              { shimmy.slice(-1) }
            </h2>
          </div>
        </ShimmyZone>
      </div>
    );
  }
}

const Logo = withRouter(withShimmy(LogoArea, 'hiring-breadcrumbs'));

const Navigation = ({ handleClick }) => (
  <div className="pairin-hiring-navigation">
    <div className="pairin-hiring-navigation-inner">
      <NavLink to="/hiring/openings"><OpeningSvg />Openings</NavLink>
      <NavLink to="/hiring/employees"><UserSvg />People</NavLink>
      <NavLink to="/hiring/targets"><TargetSvg />Targets</NavLink>
    </div>
  </div>
);

const SECTIONS = {
  openings: {
    points: [0,40,40,0]
  },
  employees: {
    points: [10,30,30,10]
  },
  employee: {
    points: [10,30,30,10]
  },
  reports: {
    points: [30,10,10,30]
  },
  targets: {
    points: [40,0,0,40]
  }
};

class HiringHeader extends React.Component {
  state = {
    section: null,
    collapsed: true
  }

  static getDerivedStateFromProps(props) {
    let re = PathToRegexp('/:app?/:section/:sub*', [], {end:false});
    const val = (re.exec(props.location.pathname) || []).slice(1).filter(c=>c&&c!='hiring');

    return {
      section: resolve(val, '0', null),
      collapsed: !!resolve(val, '1', null)
    };
  }

  get points() {
    if (this.state.section && SECTIONS[this.state.section] && !this.state.collapsed) {
      return SECTIONS[this.state.section].points;
    }
    return [0,0,0,0];
  }

  render() {
    const {
      section,
      collapsed
    } = this.state;

    return (
      <Fragment>
        <Helmet>
          <body className={`application-hiring theme-${section}`} />
        </Helmet>
        <div className="pairin-hiring-spacer"></div>
        <div className={['pairin-hiring-header',collapsed?'small':null].filter(c=>c).join(' ')}>
          <div className="pairin-hiring-masthead">
            <div className="pairin-hiring-masthead-inner">
              <Logo collapsed={collapsed} />
              <div className="pairin-hiring-masthead-inner-navigation">
                <Navigation />
                <ShimmyZone namespace="hiring-navigation-buttons" />
              </div>
            </div>
            <svg className="pairin-hiring-masthead-svg" width="100%" height="100px" viewBox="0 0 100 50" preserveAspectRatio="none">
              <path className="pairin-hiring-masthead-svg-first" fill="#fff" strokeWidth="0" d={`M0,${this.points[0]} 100,${this.points[1]} 100,50 0,50`}></path>
              <path className="pairin-hiring-masthead-svg-second" fill="rgba(255,255,255,.2)" strokeWidth="0" d={`M0,${this.points[2]} 100,${this.points[3]} 100,50 0,50`}></path>
            </svg>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(HiringHeader);
